import React from 'react';
import { BASKET_URL } from 'pages/common/consts/basket';
import { Cart as CartCommon } from 'pages/common/components/Cart';
import { useBasketState } from 'pages/common/store/basket';
import { getUpdatedBasket } from 'pages/common/helpers/get-updated-basket';
import { sendBasketSnackbar } from 'pages/common/helpers/send-basket-snackbar';
import { getProductQuantityInBasket } from 'pages/common/helpers/get-product-quantity-in-basket';
import { addComplimentaryProductsToBasketArr } from 'pages/common/helpers/add-complimentary-products-to-basket-arr';
import { TProjectConfigurationGeneralItem } from 'pages/common/types';
import { useSavedProjectsCalculationState } from '../../store/calculation';
import { getComplimentaryProductInfoForBasket } from '../../helpers/get-complimentary-product-info-for-basket';

export const Cart: React.FC = () => {
  const { calculationFormState, setCalculationState } = useSavedProjectsCalculationState();
  const { basket, addProductsToBasket } = useBasketState();

  const {
    addToCartIsSuccessful,
    mainProduct,
    complementaryProducts,
    checkedProducts,
    complimentaryGroups,
  } = calculationFormState;
  const { code, quantity } = mainProduct as TProjectConfigurationGeneralItem;
  const productQuantityInBasket = getProductQuantityInBasket(basket, code);
  const mainProductBasketInfo = getUpdatedBasket(basket, {
    code,
    quantity: productQuantityInBasket + quantity,
  });
  const complementaryProductsBasketInfo = getComplimentaryProductInfoForBasket({
    complementaryProducts,
    complimentaryGroups,
    checkedProducts,
  });
  const basketProducts = addComplimentaryProductsToBasketArr({
    basketArr: mainProductBasketInfo,
    complimentaryProductInfoForBasket: complementaryProductsBasketInfo,
  });
  const handleClick = async () => {
    document.body.addEventListener(
      'basket:update',
      e =>
        sendBasketSnackbar({
          e: e as CustomEvent,
          countMainProduct: quantity,
          countMainProductInBasket: productQuantityInBasket,
          mainProductId: code,
        }),
      { once: true }
    );
    addProductsToBasket(basketProducts);
    setCalculationState(prevState => ({
      ...prevState,
      addToCartIsSuccessful: true,
    }));
  };

  const onClickBasket = () => {
    window.open(`${window?.location?.origin}/${BASKET_URL}/`, '_blank', 'noopener noreferrer');
  };

  return (
    <CartCommon
      onClickBasket={onClickBasket}
      onClickToBasket={handleClick}
      addToCartIsSuccessful={addToCartIsSuccessful}
    />
  );
};
